import styled from 'styled-components';

// Import assets
import { ReactComponent as IconInfo } from 'assets/icons/ic_info.svg';

// Import styles
import { flex, transitionMain } from 'components/styles';

export const StyledIconInfo = styled(IconInfo)`
	color: ${({ theme }) => theme.palette.primary.main};
	width: 100%;
	height: 100%;
	${transitionMain}
`;

export const StyledButton = styled.button`
	${flex()}
	cursor: pointer;
	background: none;
	border: none;
	outline: none;
	width: 2rem;
	height: 2rem;

	&:hover {
		svg {
			color: ${({ theme }) => theme.configurator.color.secondary};
		}
	}
`;
